<template>
    <div id="customer_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="customerHeader1" v-if="$route.params.id > 0">Update Dealer</span>
                    <span class="page-title" id="customerHeader2" v-else>Add Dealer</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="backButton">
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content customer-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="needs-validation" novalidate id="CustomerForm" v-show="showDealerCreateForm">
                                <!-- dealer account section -->
                                <div>
                                    <h5 class="col section-title pl-0"> Dealer Account </h5>
                                </div>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label " for="dealer_code">Dealer Code</label>
                                        <input type="text" class="form-control" v-model="dealer_code" id="dealer_code"
                                            placeholder="Enter Dealer Code" name="dealer_code" ref="dealer_code">
                                        <div class="field-error">{{ dealer_code_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label " for="bill_cus_id">BillCusId</label>
                                        <v-select v-model="bill_cus_id" id="bill_cus_id" name="bill_cus_id"
                                            data-info="Please select billCusId" label="text" :filterable="false"
                                            :options="billCusIdArr" @search="onSearchBillCusId"
                                            placeholder="Select BillCusId" class="custom-ci-auto-search"
                                            :ref="bill_cus_id">
                                            <template slot="no-options">
                                                Search BillCusId...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ bill_cus_id_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label " for="dealer_name">Dealer Name</label>
                                        <input type="text" class="form-control" v-model="dealer_name" id="dealer_name"
                                            placeholder="Enter Dealer Name" name="dealer_name" ref="dealer_name">
                                        <div class="field-error">{{ dealer_name_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label " for="dealer_group_name">Dealer Group
                                            Name</label>
                                        <input type="text" class="form-control" v-model="dealer_group_name"
                                            id="dealer_group_name" placeholder="Enter Dealer Group Name"
                                            name="dealer_group_name" ref="dealer_group_name">
                                        <div class="field-error">{{ dealer_group_name_error_msg }}</div>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label ">Account Status</label>
                                        <div class="custome-radiobtn">
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="status-active">Active
                                                    <input type="radio" v-model="account_status" value="active"
                                                        ref="account_status" id="status-active">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom"
                                                    for="status-inactive">Inactive
                                                    <input type="radio" v-model="account_status" value="inactive"
                                                        id="status-inactive">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom"
                                                    for="status-unverified">Unverified
                                                    <input type="radio" v-model="account_status" value='unverified'
                                                        id="status-unverified">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="field-error">{{ account_status_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label ">Account Creation Date</label>
                                        <div class="input-group">
                                            <date-picker disabled placeholder="MM/DD/YYYY" id="account_creation_date"
                                                name="account_creation_date" :config="dateOptions"
                                                v-model="account_creation_date" disabled></date-picker>
                                            <label for="account_creation_date"
                                                class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{ account_creation_date_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label " for="stage">Stage</label>
                                        <v-select v-model="stage" id="stage" name="stage"
                                            data-info="Please select Stage" label="text" :filterable="false"
                                            :options="stageArr" :searchable="false" :clearable="false"
                                            placeholder="Select Stage" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Stage...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                    </div>
                                </div>
                                <!-- billing section -->
                                <div class="mt-3">
                                    <h5 class="col section-title pl-0">Billing </h5>
                                </div>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label " for="company_name">Company Name</label>
                                        <input type="text" class="form-control" v-model="billing_company_name"
                                            id="company_name" placeholder="Enter Company Name" name="company_name"
                                            ref="billing_company_name">
                                        <div class="field-error">{{ billing_company_name_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label " for="billing_address">Address</label>
                                        <input type="text" class="form-control" v-model="billing_address"
                                            id="billing_address" placeholder="Enter Dealer Group Name"
                                            name="billing_address" ref="billing_address">
                                        <div class="field-error">{{ billing_address_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label " for="city">City</label>
                                        <input type="text" class="form-control" v-model="city" id="city"
                                            placeholder="Enter City Name" name="city" ref="city">
                                        <div class="field-error">{{ city_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label " for="state">{{ state_province }}:</label>
                                        <v-select v-model="state" id="state" name="state"
                                            :data-info="`Please Select ${state_province}`"  label="text" :filterable="false"
                                            :options="stateArr" @search="onSearchState" :placeholder="`Select ${state_province}`"
                                            class="custom-ci-auto-search" ref="state">
                                            <template slot="no-options">
                                                Search {{state_province}}...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ state_error_msg }}</div>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label " for="zip_code">{{zip_postal}}</label>
                                        <input type="text" class="form-control" v-model="zip_code" id="zip_code"
                                            placeholder="Enter Code" name="zip_code" ref="zip_code">
                                        <div class="field-error">{{ zip_code_error_msg }}</div>
                                    </div>
                                </div>
                                <!-- ship to section -->
                                <div ref="shipToRows"
                                    class="form-row row-cols-md-6 row-cols-1 mb-1 mt-3 align-items-center">
                                    <h5 class="col section-title mb-0"> Ship To </h5>
                                    <div class="col">
                                        <button type="submit" v-on:click.prevent="addShipToRow()"
                                            class="btn btn-primary">
                                            <i class="fp-add"></i>Add
                                        </button>
                                    </div>
                                </div>
                                <div class="table-responsive-sm table-mt-10">
                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" style="width: 3%;">#</th>
                                                <th scope="col" style="width: 15%;">Company Name</th>
                                                <th scope="col" style="width: 20%;">Address</th>
                                                <th scope="col" style="width: 15%;">{{state_province}}</th>
                                                <th scope="col" style="width: 15%;">City</th>
                                                <th scope="col" style="width: 15%;">{{zip_postal}}</th>
                                                <th scope="col" style="width: 5%;">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="shipToRows.length > 0">
                                                <template v-for="(row, index) in shipToRows">
                                                    <tr :key="index">
                                                        <td>
                                                            {{ index + 1 }}
                                                        </td>
                                                        <td>
                                                            <input type="text" placeholder="Enter Company Name"
                                                                v-model="row.company_name" :id="'company_name' + index"
                                                                class="form-control">
                                                            <div class="field-error">{{ row.company_name_error_msg }}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <input type="text" placeholder="Enter Address"
                                                                v-model="row.address" :id="'address' + index"
                                                                class="form-control">
                                                            <div class="field-error">{{ row.address_error_msg }}</div>
                                                        </td>
                                                        <td>
                                                            <v-select v-model="row.state_id" :id="'row_state_' + index"
                                                                :data-info="`Please Select ${state_province}`" label="text"
                                                                :filterable="false" :options="row.stateArr"
                                                                @search="(search, loading) => onSearchStateShipToLineItem(search, loading, index)"
                                                                :placeholder="`Please Select ${state_province}`"
                                                                class="custom-ci-auto-search">
                                                                <template slot="no-options">
                                                                    Search {{state_province}}...
                                                                </template>
                                                                <template slot="option" slot-scope="option">
                                                                    <div class="d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                                </template>
                                                                <template slot="selected-option" slot-scope="option">
                                                                    <div class="selected d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                                </template>
                                                            </v-select>
                                                            <div class="field-error">{{ row.state_id_error_msg }}</div>
                                                        </td>
                                                        <td>
                                                            <input type="text" placeholder="City" v-model="row.city"
                                                                :id="'city_' + index" class="form-control">
                                                            <div class="field-error">{{ row.city_error_msg }}</div>
                                                        </td>
                                                        <td>
                                                            <input type="text" placeholder="Code"
                                                                v-model="row.zipcode" :id="'zipcode_' + index"
                                                                class="form-control">
                                                            <div class="field-error">{{ row.zipcode_error_msg }}</div>
                                                        </td>
                                                        <td class="text-center" style="vertical-align:middle;">
                                                            <template>
                                                                <a href="javascript:void(0);"
                                                                    v-on:click="removeShipToRow(index);"> <i
                                                                        class="fp-delete"></i> </a>
                                                            </template>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                                <!-- dealer pro admin section -->
                                <div class="mt-4">
                                    <h5 class="col section-title pl-0">Dealer Pro Admin </h5>
                                </div>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label " for="name">Name</label>
                                        <input type="text" class="form-control" v-model="name" id="name"
                                            placeholder="Enter Name" name="name" ref="name">
                                        <div class="field-error">{{ name_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label " for="title">Title</label>
                                        <input type="text" class="form-control" v-model="title" id="title"
                                            placeholder="Enter Title" name="title" ref="title">
                                        <div class="field-error">{{ title_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label " for="email">Email</label>
                                        <input type="text" class="form-control" v-model="email" id="email"
                                            placeholder="Enter Email" name="email" ref="email">
                                        <div class="field-error">{{ email_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label " for="phone">Phone</label>
                                        <input type="text" @keypress="isNumber($event)"
                                            v-cleave="{ delimiter: '-', blocks: [3, 3, 4] }" class="form-control"
                                            v-model="phone" id="phone" placeholder="999-999-9999" name="phone"
                                            ref="phone">
                                        <div class="field-error">{{ phone_error_msg }}</div>
                                    </div>
                                </div>
                                <!-- rates section -->
                                <div class="mt-3">
                                    <h5 class="col section-title pl-0">Rates </h5>
                                </div>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label " for="labor_rate">Approved Warranty {{ labor_spelling }}
                                            Rate</label>
                                        <input type="text" class="form-control" v-model="approved_labor_rate"
                                            id="labor_rate" :placeholder="labor_spelling + ' Rate ($)'" ref="approved_labor_rate"
                                            @keypress="filterNumericValue" v-on:keyup="formatNumeric('labor_rate')">
                                        <div class="field-error">{{ approved_labor_rate_error_msg }}</div>
                                        <div class="text-right">
                                            <small>
                                                <a href="javascript:void(0)" v-on:click.prevent="goToGetLogInfo(rateId)"
                                                    style="color: var(--color-blue);font-weight: bold;"
                                                    v-if="canViewLog">View
                                                    Rate change History</a>
                                            </small>
                                            <!-- todo need to link the rate change history here! -->
                                        </div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label " for="labor_last_change_date">Date of Last
                                            Change</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="labor_last_change_date"
                                                name="labor_last_change_date" :config="dateOptions"
                                                v-model="labor_last_change_date"
                                                ref="labor_last_change_date"></date-picker>
                                            <label for="labor_last_change_date"
                                                class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{ labor_last_change_date_error_msg }}</div>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label " for="travel_rate">Approved Travel
                                            Rate (Time)</label>
                                        <input type="text" class="form-control" v-model="approved_travel_time_rate"
                                            id="travel_rate" placeholder="Travel Rate ($)"
                                            ref="approved_travel_time_rate" @keypress="filterNumericValue"
                                            v-on:keyup="formatNumeric('travel_rate')">
                                        <div class="field-error">{{ approved_travel_time_rate_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label " for="travel_time_last_change_date">Date of Last
                                            Change (Time)</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="travel_time_last_change_date"
                                                name="travel_time_last_change_date" :config="dateOptions"
                                                v-model="travel_time_last_change_date"
                                                ref="travel_time_last_change_date"></date-picker>
                                            <label for="travel_time_last_change_date"
                                                class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{ travel_time_last_change_date_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label " for="travel_rate">Approved Travel
                                            Rate (Distance)</label>
                                        <input type="text" class="form-control" v-model="approved_travel_distance_rate"
                                            id="travel_rate" placeholder="Travel Rate ($)"
                                            ref="approved_travel_distance_rate" @keypress="filterNumericValue"
                                            v-on:keyup="formatNumeric('travel_rate')">
                                        <div class="field-error">{{ approved_travel_distance_rate_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label " for="travel_distance_last_change_date">Date of
                                            Last
                                            Change (Distance)</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="travel_distance_last_change_date"
                                                name="travel_distance_last_change_date" :config="dateOptions"
                                                v-model="travel_distance_last_change_date"
                                                ref="travel_distance_last_change_date"></date-picker>
                                            <label for="travel_distance_last_change_date"
                                                class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{ travel_distance_last_change_date_error_msg }}</div>
                                    </div>
                                </div>
                                <!-- primary contacts section -->
                                <div ref="primaryContactRows"
                                    class="form-row row-cols-md-6 row-cols-1 mb-1 mt-3 align-items-center">
                                    <h5 class="col section-title mb-0"> Primary Contacts </h5>
                                    <div class="col">
                                        <button type="submit" v-on:click.prevent="addPrimaryContactRow()"
                                            class="btn btn-primary">
                                            <i class="fp-add"></i>Add
                                        </button>
                                    </div>
                                </div>
                                <div class="table-responsive-sm table-mt-10">
                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" style="width: 3%;">#</th>
                                                <th scope="col" style="width: 20%;">Contact Type</th>
                                                <th scope="col" style="width: 15%;">Name</th>
                                                <th scope="col" style="width: 15%;">Email</th>
                                                <th scope="col" style="width: 15%;">Phone</th>
                                                <th scope="col" style="width: 5%;">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="primaryContactRows.length > 0">
                                                <template v-for="(row, index) in primaryContactRows">
                                                    <tr :key="index">
                                                        <td>
                                                            {{ index + 1 }}
                                                        </td>
                                                        <td>
                                                            <v-select v-model="row.contact_type"
                                                                :id="'contact_type' + index" name="contact_type"
                                                                placeholder="Select Contact Type" label="text"
                                                                :options="contactTypeArr">
                                                            </v-select>
                                                            <div class="field-error">{{ row.contact_type_error_msg }}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <input type="text" placeholder="Enter Name"
                                                                v-model="row.contact_name" :id="'name_' + index"
                                                                class="form-control">
                                                            <div class="field-error">{{ row.contact_name_error_msg }}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <input type="text" placeholder="Enter Email"
                                                                v-model="row.contact_email" :id="'email_' + index"
                                                                class="form-control">
                                                            <div class="field-error">{{ row.contact_email_error_msg }}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <input type="text"
                                                                v-cleave="{ delimiter: '-', blocks: [3, 3, 4] }"
                                                                placeholder="999-999-9999" v-model="row.contact_phone"
                                                                @keypress="isNumber($event)" :id="'phone_' + index"
                                                                class="form-control">
                                                            <div class="field-error">{{ row.contact_phone_error_msg }}
                                                            </div>
                                                        </td>
                                                        <td class="text-center" style="vertical-align:middle;">
                                                            <template>
                                                                <a href="javascript:void(0);"
                                                                    v-on:click="removePrimaryContactRow(index);"> <i
                                                                        class="fp-delete"></i> </a>
                                                            </template>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                                <!-- software section -->
                                <div ref="softwareRows"
                                    class="form-row row-cols-md-6 row-cols-1 mb-1 mt-4 align-items-center">
                                    <h5 class="col section-title mb-0"> Software </h5>
                                    <div class="col">
                                        <button type="submit" v-on:click.prevent="addSoftwareRow()"
                                            class="btn btn-primary">
                                            <i class="fp-add"></i>Add
                                        </button>
                                    </div>
                                </div>
                                <div class="table-responsive-sm table-mt-10">
                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" style="width: 3%;">#</th>
                                                <th scope="col" style="width: 15%;">Software Name</th>
                                                <th scope="col" style="width: 15%;">Start Date</th>
                                                <th scope="col" style="width: 15%;">Expiry Date</th>
                                                <th scope="col" style="width: 15%;">Invoice#</th>
                                                <th scope="col" style="width: 15%;">Admin Name</th>
                                                <th scope="col" style="width: 5%;">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="softwareRows.length > 0">
                                                <template v-for="(row, index) in softwareRows">
                                                    <tr :key="index">
                                                        <td>
                                                            {{ index + 1 }}
                                                        </td>
                                                        <td>
                                                            <v-select v-model="row.software_name"
                                                                :id="'software_name' + index" name="software_name"
                                                                placeholder="Select Contact Type" label="text"
                                                                :options="softwareNameArr">
                                                            </v-select>
                                                            <div class="field-error">{{ row.software_name_error_msg }}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="form-group mb-0">
                                                                <div class="input-group">
                                                                    <date-picker placeholder="MM/DD/YYYY"
                                                                        :id="'start_date_' + index"
                                                                        :name="'start_date_' + index"
                                                                        :config="dateOptions"
                                                                        v-model="row.start_date"></date-picker>
                                                                    <label for="start_date"
                                                                        class="fp-calendar input-calender-icon"></label>
                                                                </div>
                                                                <div class="field-error">{{ row.start_date_error_msg }}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="form-group mb-0">
                                                                <div class="input-group">
                                                                    <date-picker placeholder="MM/DD/YYYY"
                                                                        :id="'exp_date_' + index"
                                                                        :name="'exp_date_' + index"
                                                                        :config="dateOptions"
                                                                        v-model="row.exp_date"></date-picker>
                                                                    <label for="exp_date"
                                                                        class="fp-calendar input-calender-icon"></label>
                                                                </div>
                                                                <div class="field-error">{{ row.exp_date_error_msg }}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <input type="text" placeholder="Invoice Number"
                                                                v-model="row.invoice_number"
                                                                :id="'invoice_number' + index" class="form-control">
                                                            <div class="field-error">{{ row.invoice_number_error_msg }}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <input type="text" placeholder="Admin Name"
                                                                v-model="row.admin_name" :id="'admin_name' + index"
                                                                class="form-control">
                                                            <div class="field-error">{{ row.admin_name_error_msg }}
                                                            </div>
                                                        </td>
                                                        <td class="text-center" style="vertical-align:middle;">
                                                            <template>
                                                                <a href="javascript:void(0);"
                                                                    v-on:click="removeSoftwareRow(index);"> <i
                                                                        class="fp-delete"></i> </a>
                                                            </template>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                                <!-- invoice delivery section -->
                                <div class="mt-4">
                                    <h5 class="col section-title pl-0"> Invoice Delivery </h5>
                                </div>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label " for="invoice_delivery_email">Invoice/credit
                                            Memo
                                            Delivery Email</label>
                                        <input type="text" class="form-control" v-model="invoice_delivery_email"
                                            id="invoice_delivery_email" placeholder="Enter Email Address"
                                            ref="invoice_delivery_email">
                                        <div class="field-error">{{ invoice_delivery_email_error_msg }}</div>
                                    </div>
                                </div>
                                <!-- documents section -->
                                <div ref="documentRows"
                                    class="form-row row-cols-md-6 row-cols-1 mb-1 mt-4 align-items-center">
                                    <h5 class="col section-title mb-0"> Documents </h5>
                                    <div class="col">
                                        <button type="submit" v-on:click.prevent="addDocumentRow()"
                                            class="btn btn-primary">
                                            <i class="fp-add"></i>Add
                                        </button>
                                    </div>
                                </div>
                                <div class="table-responsive-sm table-mt-10">
                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" style="width: 3%;">#</th>
                                                <th scope="col" style="width: 15%;">Document Type</th>
                                                <th scope="col" style="width: 15%;">Upload Document</th>
                                                <th scope="col" style="width: 5%;">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="documentRows.length > 0">
                                                <template v-for="(row, index) in documentRows">
                                                    <tr :key="index">
                                                        <td>
                                                            {{ index + 1 }}
                                                        </td>
                                                        <td>
                                                            <v-select v-model="row.document_type"
                                                                :id="'document_type' + index" name="document_type"
                                                                placeholder="Select Document Type" label="text"
                                                                :options="documentTypeArr">
                                                            </v-select>
                                                            <div class="field-error">{{ row.document_type_error_msg }}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <template v-if="row.file_link == null">
                                                                <input type="file"
                                                                    @change="handleSelectedFile($event, index)"
                                                                    :id="'file_' + index" class="form-control p-0">
                                                                <div class="field-error ml-0">{{ row.file_error_msg }}
                                                                </div>
                                                            </template>
                                                            <template v-else>
                                                                <div class="row">
                                                                    <div class="col d-flex align-items-center">
                                                                        <a v-on:click="goToGetDocumentPath($event, row.file_link)"
                                                                            title="View Dealer Document"
                                                                            href="javascript:void(0);"
                                                                            style="font-size: 15px;">
                                                                            <i class="fp-text-document"></i> Attached
                                                                            File
                                                                        </a>
                                                                        <a href="javascript:void(0);"
                                                                            style="margin-left: 15px;margin-top: 4px;"
                                                                            v-on:click="removeFileLink(index);"
                                                                            class="ms-1">
                                                                            <i class="fp-remove"></i>
                                                                        </a>
                                                                    </div>
                                                                    <div class="col"></div>
                                                                </div>
                                                            </template>

                                                        </td>
                                                        <td class="text-center" style="vertical-align:middle;">
                                                            <template>
                                                                <a href="javascript:void(0);"
                                                                    v-on:click="removeDocumentRow(index);"> <i
                                                                        class="fp-delete"></i> </a>
                                                            </template>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                                <!-- rizon representative section -->
                                <div class="mt-4">
                                    <h5 class="col section-title pl-0"> RIZON Representative </h5>
                                </div>
                                <b>Truck Sales Person</b>

                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label ">Name</label>
                                        <input type="text" class="form-control" v-model="truck_sales_person_name"
                                            id="truck_sales_person_name" placeholder="Enter Name"
                                            ref="truck_sales_person_name">
                                        <div class="field-error ml-0">{{ truck_sales_person_name_error_msg }}
                                        </div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label ">Email</label>
                                        <input type="text" class="form-control" v-model="truck_sales_person_email"
                                            id="truck_sales_person_email" placeholder="Enter Email"
                                            ref="truck_sales_person_email">
                                        <div class="field-error ml-0">{{ truck_sales_person_email_error_msg }}
                                        </div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label ">Assigned Date</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" :id="truck_sales_person_assigned_date"
                                                name="truck_sales_person_assigned_date" :config="dateOptions"
                                                v-model="truck_sales_person_assigned_date"
                                                ref="truck_sales_person_assigned_date"></date-picker>
                                            <label for="truck_sales_person_assigned_date"
                                                class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error ml-0">{{ truck_sales_person_assigned_date_error_msg }}
                                        </div>
                                    </div>
                                </div>
                                <b>Product Support Manager</b>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label ">Name</label>
                                        <input type="text" class="form-control" v-model="product_support_manager_name"
                                            id="product_support_manager_name" placeholder="Enter Name"
                                            ref="product_support_manager_name">
                                        <div class="field-error ml-0">{{ product_support_manager_name_error_msg }}
                                        </div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label ">Email</label>
                                        <input type="text" class="form-control" v-model="product_support_manager_email"
                                            id="product_support_manager_email" placeholder="Enter Email"
                                            ref="product_support_manager_email">
                                        <div class="field-error ml-0">{{ product_support_manager_email_error_msg }}
                                        </div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label ">Assigned Date</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY"
                                                :id="product_support_manager_assigned_date"
                                                name="product_support_manager_assigned_date" :config="dateOptions"
                                                v-model="product_support_manager_assigned_date"
                                                ref="product_support_manager_assigned_date"></date-picker>
                                            <label for="product_support_manager_assigned_date"
                                                class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error ml-0">{{ product_support_manager_assigned_date_error_msg
                                            }}
                                        </div>
                                    </div>
                                </div>
                                <!-- buttons section -->
                                <div class="btn-groups">
                                    <button type="submit" id="SaveDealerBtn" class="btn btn-primary"
                                        v-on:click.prevent="saveDealer()">
                                        <i class="fp-save"> </i> Save
                                    </button>
                                    <button type="submit" id="cancelDealerBtn" class="btn btn-tertiary" v-on:click.prevent="backButton">
                                        <i class="fp-close"> </i> Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                    <audit-log-popup :logs="logs" :popUpTitle="popUpTitle"></audit-log-popup>

                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import { commonMixins } from '../mixins/commonMixins';
import { contractMixins } from '../mixins/contractMixins';
import AuditLogPopUp from "./AuditLogPopUp.vue";
Vue.component("audit-log-popup", AuditLogPopUp);



export default {
    name: "CustomerCreate",
    metaInfo() {
        return {
            title: (this.$route.params.id > 0) ? "Update Dealer | " + process.env.COPYRIGHT_NAME : "Create Dealer | " + process.env.COPYRIGHT_NAME
        }
    },
    mixins: [commonMixins, contractMixins],
    data: () => ({
        loading: false,
        cantAccessPage: '',
        permissions: [],
        dealer_code: '',
        dealer_code_error_msg: '',
        bill_cus_id: '',
        bill_cus_id_error_msg: '',
        dealer_name: '',
        dealer_name_error_msg: '',
        dealer_group_name: '',
        dealer_group_name_error_msg: '',
        account_status: '',
        account_status_error_msg: '',
        account_creation_date: '',
        account_creation_date_error_msg: '',
        dateOptions: {
            format: 'MM/DD/YYYY',
            useCurrent: false
        },
        billing_address: '',
        billing_address_error_msg: '',
        billing_company_name: '',
        billing_company_name_error_msg: '',
        city: '',
        city_error_msg: '',
        cityArr: [],
        state: '',
        state_error_msg: '',
        stateArr: [],
        zip_code: '',
        zip_code_error_msg: '',
        shipToRows: [],
        name: '',
        name_error_msg: '',
        title: '',
        title_error_msg: '',
        email: '',
        email_error_msg: '',
        phone: '',
        phone_error_msg: '',
        approved_labor_rate: '',
        approved_labor_rate_error_msg: '',
        labor_last_change_date: '',
        labor_last_change_date_error_msg: '',
        approved_travel_time_rate: '',
        approved_travel_time_rate_error_msg: '',
        travel_time_last_change_date: '',
        travel_time_last_change_date_error_msg: '',
        approved_travel_distance_rate: '',
        approved_travel_distance_rate_error_msg: '',
        travel_distance_last_change_date: '',
        travel_distance_last_change_date_error_msg: '',
        primaryContactRows: [],
        contactTypeArr: [
            "AP",
            "AR",
            "Department Managers"
        ],
        softwareRows: [],
        softwareNameArr: [
            'ASCENT',
            'XENTRY',
            'RIZON Connect'
        ],
        invoice_delivery_email: '',
        invoice_delivery_email_error_msg: '',
        documentRows: [],
        documentTypeArr: [
            'Labor Rate Increase Request',
            'Banking Docs',
            'Software User Lists',
            'Dealer Agreements/Contracts'
        ],
        truck_sales_person_name: '',
        truck_sales_person_name_error_msg: '',
        truck_sales_person_email: '',
        truck_sales_person_email_error_msg: '',
        truck_sales_person_assigned_date: '',
        truck_sales_person_assigned_date_error_msg: '',
        product_support_manager_name: '',
        product_support_manager_name_error_msg: '',
        product_support_manager_email: '',
        product_support_manager_email_error_msg: '',
        product_support_manager_assigned_date: '',
        product_support_manager_assigned_date_error_msg: '',
        isEdit: false,
        dealerId: null,
        shipToRowsToDelete: [],
        primaryContactRowsToDelete: [],
        softwareRowsToDelete: [],
        documentRowsToDelete: [],
        billCusIdArr: [],
        logs: [],
        popUpTitle: "Rate Activity Log Details",
        canViewLog: false,
        rateId: null,
        showDealerCreateForm: true,
        stageArr: [
            { text: 'Account Pending', value: 'account pending' },
            { text: 'Credit Approved', value: 'credit approved' },
            { text: 'Credit Denied', value: 'credit denied' },
            { text: 'Existing', value: 'existing' },
            { text: 'New', value: 'new' },
            { text: 'Pending Approval', value: 'potential' }
        ],
        stage: ''
    }),

    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'ev_add_dealer') {
                        self.cantAccessPage = true;
                    }
                    if (permissions[i].name == 'ev_view_log_rate') {
                        self.canViewLog = true;
                    }
                }
            }
        },
    },
    created: function () {

    },
    mounted: function () {
        var self = this;
        self.getPermissions();

        self.shipToRows.push({
            id: '',
            company_name: '',
            company_name_error_msg: '',
            address: '',
            address_error_msg: '',
            state_id: '',
            state_id_error_msg: '',
            city: '',
            city_error_msg: '',
            zipcode: '',
            zipcode_error_msg: '',
            stateArr: [],
            cityArr: []
        });
        self.primaryContactRows.push({
            contact_id: '',
            contact_type: '',
            contact_type_error_msg: '',
            contact_name: '',
            contact_name_error_msg: '',
            contact_email: '',
            contact_email_error_msg: '',
            contact_phone: '',
            contact_phone_error_msg: ''
        });
        self.softwareRows.push({
            id: '',
            software_name: '',
            software_name_error_msg: '',
            start_date: '',
            start_date_error_msg: '',
            exp_date: '',
            exp_date_error_msg: '',
            invoice_number: '',
            invoice_number_error_msg: '',
            admin_name: '',
            admin_name_error_msg: '',
        });
        self.documentRows.push({
            id: '',
            document_type: '',
            document_type_error_msg: '',
            file: '',
            file_error_msg: '',
            file_link: null,
            dealer_id: ''
        });

        var path = window.location.pathname;
        var segments = path.split("/");
        if (segments[3]) {
            self.dealerId = segments[3];

            self.isEdit = true;
            self.loadDealer();
        } else {
            self.dealerId = 0;
        }
    },
    methods: {
        onSearchState(search, loading) {
            var self = this;
            if ((search.trim()).length > 0) {
                loading(true);
                self.searchField(loading, search, 'state', '');
            }
        },
        onSearchCity(search, loading) {
            var self = this;
            if (search.length > 2) {
                var stateId = self.state.value;
                if (stateId == "") {
                    alert("please select state first");
                    return;
                }
                loading(true);
                self.searchField(loading, search, 'city', '');
            }
        },
        onSearchStateShipToLineItem(search, loading, index) {
            var self = this;
            if ((search.trim()).length > 0) {
                loading(true);
                self.searchField(loading, search, 'state-other', '', null, null, index);
            }
        },
        onSearchCityShipToLineItem(search, loading, index) {
            var self = this;
            if (search.length > 2) {
                var stateId = self.shipToRows[index].state.value;
                if (stateId == "") {
                    alert("please select state first");
                    return;
                }
                loading(true);
                self.searchField(loading, search, 'city-other', '', null, null, index);
            }
        },

        rowCityChanged(newValue, index) {
            if (newValue == null || newValue == '') {
                this.shipToRows[index].city = '';
            }
        },
        addShipToRow() {
            var success = this.validateShipToRows();
            if (success) {
                this.shipToRows.push({
                    id: '',
                    company_name: '',
                    company_name_error_msg: '',
                    address: '',
                    address_error_msg: '',
                    state_id: '',
                    state_id_error_msg: '',
                    city: '',
                    city_error_msg: '',
                    zipcode: '',
                    zipcode_error_msg: '',
                    stateArr: [],
                    cityArr: []
                });
            }
        },
        removeShipToRow(index) {
            if (this.shipToRows.length > 0) {
                if (this.shipToRows[index].id != "") {
                    this.shipToRowsToDelete.push({
                        id: this.shipToRows[index].id
                    });
                }
                this.shipToRows.splice(index, 1);
            }
        },
        addPrimaryContactRow() {
            var success = this.validatePrimaryContactRows();
            if (success) {
                this.primaryContactRows.push({
                    contact_id: '',
                    contact_type: '',
                    contact_type_error_msg: '',
                    contact_name: '',
                    contact_name_error_msg: '',
                    contact_email: '',
                    contact_email_error_msg: '',
                    contact_phone: '',
                    contact_phone_error_msg: '',
                });
            }
        },
        removePrimaryContactRow(index) {
            if (this.primaryContactRows.length > 0) {
                if (this.primaryContactRows[index].contact_id != "") {
                    this.primaryContactRowsToDelete.push({
                        id: this.primaryContactRows[index].contact_id
                    });
                }
                this.primaryContactRows.splice(index, 1);
            }
        },
        addSoftwareRow() {
            var success = this.validateSoftwareRows();
            if (success) {
                this.softwareRows.push({
                    id: '',
                    software_name: '',
                    software_name_error_msg: '',
                    start_date: '',
                    start_date_error_msg: '',
                    exp_date: '',
                    exp_date_error_msg: '',
                    invoice_number: '',
                    invoice_number_error_msg: '',
                    admin_name: '',
                    admin_name_error_msg: '',
                });
            }
        },
        removeSoftwareRow(index) {
            if (this.softwareRows.length > 0) {
                if (this.softwareRows[index].id != "") {
                    this.softwareRowsToDelete.push({
                        id: this.softwareRows[index].id
                    });
                }
                this.softwareRows.splice(index, 1);
            }
        },
        addDocumentRow() {
            var success = this.validateDocumentRows();
            if (success) {
                this.documentRows.push({
                    id: '',
                    document_type: '',
                    document_type_error_msg: '',
                    file: '',
                    file_error_msg: '',
                    file_link: null,
                    dealer_id: ''
                });
            }
        },
        removeDocumentRow(index) {
            if (this.documentRows.length > 0) {
                if (this.documentRows[index].id != "") {
                    this.documentRowsToDelete.push({
                        id: this.documentRows[index].id
                    });
                }
                this.documentRows.splice(index, 1);
            }
        },
        backButton() {
            if (this.$route.params.id) {
                var url = "/dealer/view/" + this.$route.params.id;
            } else {
                var url = '/dealer/list';
            }
            this.redirectPageUrl(url);
        },
        onSearchBillCusId(search, loading) {
            if (search.length > 2) {

                loading(true);
                this.searchField(loading, search, 'billCusId');
            }
        },
        handleSelectedFile(event, index) {
            const file = event.target.files[0];
            this.documentRows[index].file_error_msg = '';
            if (file) {
                // Handling file
                const maxSize = 10000000; // 10MB
                if (file.size > maxSize) {
                    this.documentRows[index].file_error_msg = "The file size is too large. Please upload a file smaller than 10MB.";
                } else {
                    this.documentRows[index].file = file;
                }
            }
        },
        loadDealer() {
            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.isEdit = true;
            self.loading = true;
            var id = 0;
            if (segments[3]) {
                id = segments[3];
            }
            $.ajax({
                url: process.env.ROOT_API + "/customer/" + id,
                type: "GET",
                headers: this.ajxHeaders,
                data: {
                    flag: "save",
                    action_flag: 'edit', // pass action for notify: view, edit
                    is_notify_flag: true // notify if user viewing or editing
                },
                dataType: "json",
                success: function (data) {
                    self.loading = false;

                    if (data.status == "success") {
                        if (data.code == 200) {
                            self.dealer_code = data.content.code;
                            self.bill_cus_id = { value: data.content.parent_id, text: data.content.pcust_code };
                            self.dealer_name = data.content.name;
                            self.dealer_group_name = data.content.dealer_group_name;
                            self.account_status = data.content.status;
                            self.account_creation_date = data.content.account_creation_date;
                            self.stage = data.content.stage ?
                                {
                                    text: data.content.stage === 'potential'
                                        ? 'Pending Approval'
                                        : self.ucString(data.content.stage),
                                    value: data.content.stage
                                }
                                : "";
                            self.billing_address = data.content.address_line_1;
                            self.billing_company_name = data.content.company_name;
                            self.city = data.content.city_name;
                            self.state = { value: data.content.state_id, text: data.content.stateName };
                            self.zip_code = data.content.postcode;
                            self.populateShipToRows(data.content.dealer_account_ship_to_locations);
                            self.approved_labor_rate = data.content.labor_rate;
                            self.approved_travel_time_rate = data.content.time_travel_rate;
                            self.approved_travel_distance_rate = data.content.distance_travel_rate;

                            self.labor_last_change_date = data.content.labor_rate_change_date;
                            self.travel_time_last_change_date = data.content.time_travel_rate_change_date;
                            self.travel_distance_last_change_date = data.content.distance_travel_rate_change_date;
                            self.populatePrimaryContactsRows(data.content.customer_contacts);
                            self.softwareRows = data.content.dealer_account_softwares;
                            self.invoice_delivery_email = data.content.invoice_delivery_email;

                            self.name = data.content.dealer_pro_admin_name;
                            self.title = data.content.dealer_pro_admin_title;
                            self.email = data.content.dealer_pro_admin_email;
                            self.phone = data.content.dealer_pro_admin_phone;

                            self.truck_sales_person_name = data.content.truck_sales_person_name;
                            self.truck_sales_person_email = data.content.truck_sales_person_email;
                            self.truck_sales_person_assigned_date = data.content.truck_sales_person_assigned_date;

                            self.product_support_manager_name = data.content.product_support_manager_name;
                            self.product_support_manager_email = data.content.product_support_manager_email;
                            self.product_support_manager_assigned_date = data.content.product_support_manager_assigned_date;

                            self.rateId = data.content.rate_id;
                            self.showDealerCreateForm = true;

                            self.populateDocumentRows(data.content.dealer_account_documents);
                            self.populateAmounts();
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.showDealerCreateForm = false;
                    self.generateStatusCodeMessage(jqXHR, true, 'create-customer-load')
                }
            });
        },
        saveDealer() {
            var self = this;
            self.loading = true;
            var success = self.validateFieldsNew();
            if (success) {
                var fields = {
                    id: self.dealerId,
                    dealer_code: self.dealer_code,
                    bill_cus_id: self.bill_cus_id,
                    dealer_name: self.dealer_name,
                    dealer_group_name: self.dealer_group_name,
                    account_status: self.account_status,
                    account_creation_date: self.account_creation_date,
                    stage: self.stage ? self.stage.value : 'potential',
                    billing_address: self.billing_address,
                    billing_company_name: self.billing_company_name,
                    city: self.city,
                    cityArr: self.cityArr,
                    state: self.state,
                    stateArr: self.stateArr,
                    zip_code: self.zip_code,
                    shipToRows: self.shipToRows,
                    name: self.name,
                    title: self.title,
                    email: self.email,
                    phone: self.phone,
                    approved_labor_rate: self.customFunctionForAmountFormat(self.approved_labor_rate),
                    labor_last_change_date: self.labor_last_change_date,
                    approved_travel_time_rate: self.customFunctionForAmountFormat(self.approved_travel_time_rate),
                    travel_time_last_change_date: self.travel_time_last_change_date,
                    approved_travel_distance_rate: self.customFunctionForAmountFormat(self.approved_travel_distance_rate),
                    travel_distance_last_change_date: self.travel_distance_last_change_date,
                    primaryContactRows: self.primaryContactRows,
                    softwareRows: self.softwareRows,
                    invoice_delivery_email: self.invoice_delivery_email,
                    documentRows: self.documentRows,
                    truck_sales_person_name: self.truck_sales_person_name,
                    truck_sales_person_email: self.truck_sales_person_email,
                    truck_sales_person_assigned_date: self.truck_sales_person_assigned_date,
                    product_support_manager_name: self.product_support_manager_name,
                    product_support_manager_email: self.product_support_manager_email,
                    product_support_manager_assigned_date: self.product_support_manager_assigned_date,
                    shipToRowsToDelete: self.shipToRowsToDelete,
                    primaryContactRowsToDelete: self.primaryContactRowsToDelete,
                    softwareRowsToDelete: self.softwareRowsToDelete,
                    documentRowsToDelete: self.documentRowsToDelete
                };

                let formData = new FormData();
                formData.append("dealerAccountData", JSON.stringify(fields));
                formData = self.setAttachments(
                    formData,
                    self.documentRows,
                    'documents'
                );
                $.ajax({
                    url: process.env.ROOT_API + "/customer/create",
                    type: "POST",
                    data: formData,
                    headers: {
                        "Accept": "application/json",
                        "Access-Control-Allow-Origin": "*",
                        "Authorization": "Bearer " + localStorage.getItem("tkn"),
                        "Access-Control-Allow-Headers":
                            "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    crossDomain: true,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        var url = "/dealer/view/" + data.content.id;
                        self.redirectPageUrl(url);
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR, true, 'create-customer-message');
                    }
                })
            } else {
                self.loading = false;
                self.errorValidationFocus();
            }
        },
        validateFieldsNew() {
            var success = true;
            if(this.zip_code){
                if(this.zip_code.length >= this.zip_postal_valid_length){
                    this.zip_code = this.zip_code.slice(0,this.zip_postal_valid_length);
                }else{
                    this.zip_code_error_msg = "Enter Valid " + this.zip_postal;
                    success = false;
                }
            }
            return success;
        },
        validateFields() {
            var self = this;
            var success = true;
            let firstErrorField = null;
            self.clearErrorMessages();
            if (self.dealer_code == "" || self.dealer_code == null) {
                self.dealer_code_error_msg = "Dealer code is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'dealer_code';
            }

            if (self.bill_cus_id == "" || self.bill_cus_id == null) {
                self.bill_cus_id_error_msg = "BillCusId is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'dealer_code';
            }

            if (self.dealer_name == "" || self.dealer_name == null) {
                self.dealer_name_error_msg = "Dealer name is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'dealer_name';
            }

            if (self.dealer_group_name == "" || self.dealer_group_name == null) {
                self.dealer_group_name_error_msg = "Dealer group name is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'dealer_group_name';
            }

            if (self.account_status == "" || self.account_status == null) {
                self.account_status_error_msg = "Account status is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'account_status';
            }

            if (self.account_creation_date == "" || self.account_creation_date == null) {
                self.account_creation_date_error_msg = "Account creation date is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'account_status';
            }

            if (self.billing_address == "" || self.billing_address == null) {
                self.billing_address_error_msg = "Billing address is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'billing_address';
            }

            if (self.billing_company_name == "" || self.billing_company_name == null) {
                self.billing_company_name_error_msg = "Billing company name is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'billing_company_name';
            }

            if (self.city == "" || self.city == null) {
                self.city_error_msg = "City is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'city';
            }

            if (self.state == "" || self.state == null) {
                self.state_error_msg = "State is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'city';
            }

            if (self.zip_code == "" || self.zip_code == null) {
                self.zip_code_error_msg = "Zipcode is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'zip_code';
            } else {
                if(self.zip_code.length >= self.zip_postal_valid_length){
                    this.zip_code = this.zip_code.slice(0,self.zip_postal_valid_length);
                }else{
                    this.zip_code_error_msg = "Enter Valid " + self.zip_postal;
                    success = false;
                    if (!firstErrorField) firstErrorField = 'zip_code';
                }
            }

            if (self.shipToRows.length > 0) {
                var shipTosuccess = self.validateShipToRows();
                if (!shipTosuccess) {
                    success = shipTosuccess;
                    if (!firstErrorField) firstErrorField = 'shipToRows';
                }
            }

            if (self.name == "" || self.name == null) {
                self.name_error_msg = "Name is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'name';
            }

            if (self.title == "" || self.title == null) {
                self.title_error_msg = "Title is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'title';
            }

            if (self.email == "" || self.email == null) {
                self.email_error_msg = "Email is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'email';
            } else {
                if (!self.validEmail(self.email)) {
                    self.email_error_msg = "Enter valid email!";
                    success = false;
                    if (!firstErrorField) firstErrorField = 'email';
                }
            }

            if (self.phone == "" || self.phone == null) {
                self.phone_error_msg = "Phone is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'phone';
            }

            if (self.approved_labor_rate == "" || self.approved_labor_rate == null) {
                self.approved_labor_rate_error_msg = self.labor_spelling + " is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'approved_labor_rate';
            }

            if (self.labor_last_change_date == "" || self.labor_last_change_date == null) {
                self.labor_last_change_date_error_msg = self.labor_spelling + " last change date is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'approved_labor_rate';
            }

            if (self.approved_travel_time_rate == "" || self.approved_travel_time_rate == null) {
                self.approved_travel_time_rate_error_msg = "Travel rate (Time) is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'approved_travel_time_rate';
            }

            if (self.travel_time_last_change_date == "" || self.travel_time_last_change_date == null) {
                self.travel_time_last_change_date_error_msg = "Travel (Time) last change date is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'approved_travel_time_rate';
            }

            if (self.approved_travel_distance_rate == "" || self.approved_travel_distance_rate == null) {
                self.approved_travel_distance_rate_error_msg = "Travel rate (Distance) is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'approved_travel_distance_rate';
            }

            if (self.travel_distance_last_change_date == "" || self.travel_distance_last_change_date == null) {
                self.travel_distance_last_change_date_error_msg = "Travel (Distance) last change date is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'approved_travel_distance_rate';
            }

            if (self.primaryContactRows.length > 0) {
                var primaryContactSuccess = self.validatePrimaryContactRows();
                if (!primaryContactSuccess) {
                    success = primaryContactSuccess;
                    if (!firstErrorField) firstErrorField = 'primaryContactRows';
                }
            }

            if (self.softwareRows.length > 0) {
                var softwareSuccess = self.validateSoftwareRows()
                if (!softwareSuccess) {
                    success = softwareSuccess;
                    if (!firstErrorField) firstErrorField = 'softwareRows';
                }
            }

            if (self.documentRows.length > 0) {
                var documentSuccess = self.validateDocumentRows();
                if (!documentSuccess) {
                    success = documentSuccess;
                    if (!firstErrorField) firstErrorField = 'documentRows';
                }
            }

            if (self.invoice_delivery_email == "" || self.invoice_delivery_email == null) {
                self.invoice_delivery_email_error_msg = "Invoice delivery email is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'invoice_delivery_email';
            }

            if (self.truck_sales_person_name == "" || self.truck_sales_person_name == null) {
                self.truck_sales_person_name_error_msg = "Name is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'truck_sales_person_name';
            }

            if (self.truck_sales_person_email == "" || self.truck_sales_person_email == null) {
                self.truck_sales_person_email_error_msg = "Email is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'truck_sales_person_email';
            } else {
                if (!self.validEmail(self.truck_sales_person_email)) {
                    self.truck_sales_person_email_error_msg = "Enter valid email!";
                    success = false;
                    if (!firstErrorField) firstErrorField = 'truck_sales_person_email';
                }
            }

            if (
                self.truck_sales_person_assigned_date == ""
                ||
                self.truck_sales_person_assigned_date == null
                ||
                self.truck_sales_person_assigned_date == '0000-00-00'
            ) {
                self.truck_sales_person_assigned_date_error_msg = "Assigned date is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'truck_sales_person_email';
            }

            if (self.product_support_manager_name == "" || self.product_support_manager_name == null) {
                self.product_support_manager_name_error_msg = "Name is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'product_support_manager_name';
            }

            if (self.product_support_manager_email == "" || self.product_support_manager_email == null) {
                self.product_support_manager_email_error_msg = "Email is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'product_support_manager_email';
            } else {
                if (!self.validEmail(self.product_support_manager_email)) {
                    self.product_support_manager_email_error_msg = "Enter valid email!";
                    success = false;
                    if (!firstErrorField) firstErrorField = 'product_support_manager_email';
                }
            }

            if (
                self.product_support_manager_assigned_date == ""
                ||
                self.product_support_manager_assigned_date == null
                ||
                self.product_support_manager_assigned_date == '0000-00-00'
            ) {
                self.product_support_manager_assigned_date_error_msg = "Assigned date is required!";
                success = false;
                if (!firstErrorField) firstErrorField = 'product_support_manager_email';
            }

            // Scroll to the first error field
            if (firstErrorField) {
                this.$nextTick(() => {
                    const errorElement = this.$refs[firstErrorField];
                    if (errorElement) {
                        let elementPosition = errorElement.getBoundingClientRect().top + window.scrollY;
                        elementPosition = elementPosition - 125;
                        window.scrollTo({ top: elementPosition, behavior: 'smooth' });
                        errorElement.focus();
                    }
                });

                this.$refs[firstErrorField].scrollIntoView({ behavior: 'smooth', block: 'start' });
            }



            return success;

        },
        clearErrorMessages() {
            var self = this;
            self.dealer_code_error_msg = "";
            self.bill_cus_id_error_msg = "";
            self.dealer_name_error_msg = "";
            self.dealer_group_name_error_msg = "";
            self.account_status_error_msg = "";
            self.account_creation_date_error_msg = "";
            self.billing_address_error_msg = "";
            self.billing_company_name_error_msg = "";
            self.city_error_msg = "";
            self.state_error_msg = "";
            self.zip_code_error_msg = "";
            self.name_error_msg = "";
            self.title_error_msg = "";
            self.email_error_msg = "";
            self.phone_error_msg = "";
            self.approved_labor_rate_error_msg = "";
            self.labor_last_change_date_error_msg = "";
            self.approved_travel_time_rate_error_msg = "";
            self.travel_time_last_change_date_error_msg = "";
            self.approved_travel_distance_rate_error_msg = "";
            self.travel_distance_last_change_date_error_msg = "";
            self.invoice_delivery_email_error_msg = "";
            self.truck_sales_person_name_error_msg = "";
            self.truck_sales_person_email_error_msg = "";
            self.truck_sales_person_assigned_date_error_msg = "";
            self.product_support_manager_name_error_msg = "";
            self.product_support_manager_email_error_msg = "";
            self.product_support_manager_assigned_date_error_msg = "";
        },
        validateShipToRows() {
            var success = true;
            for (var i = 0; i < this.shipToRows.length; i++) {
                this.clearShipToRowErrorMsg(i);
                if (this.shipToRows[i].company_name == '' || this.shipToRows[i].company_name == null) {
                    this.shipToRows[i].company_name_error_msg = "Enter company name";
                    success = false;
                }
                if (this.shipToRows[i].address == '' || this.shipToRows[i].address == null) {
                    this.shipToRows[i].address_error_msg = "Enter address";
                    success = false;
                }

                if (this.shipToRows[i].state_id == '' || this.shipToRows[i].state_id == null) {
                    this.shipToRows[i].state_id_error_msg = "Enter state";
                    success = false;
                }

                if (this.shipToRows[i].city == '' || this.shipToRows[i].city == null) {
                    this.shipToRows[i].city_error_msg = "Enter city";
                    success = false;
                }

                if (this.shipToRows[i].zipcode == '' || this.shipToRows[i].zipcode == null) {
                    this.shipToRows[i].zipcode_error_msg = "Enter state";
                    success = false;
                }
            }
            return success;
        },
        clearShipToRowErrorMsg(index) {
            this.shipToRows[index].company_name_error_msg = "";
            this.shipToRows[index].address_error_msg = "";
            this.shipToRows[index].state_id_error_msg = "";
            this.shipToRows[index].city_error_msg = "";
            this.shipToRows[index].zipcode_error_msg = "";
        },
        validatePrimaryContactRows() {
            var success = true;
            for (var i = 0; i < this.primaryContactRows.length; i++) {
                this.clearPrimaryContactRowErrorMsg(i);
                if (this.primaryContactRows[i].contact_type == '' || this.primaryContactRows[i].contact_type == null) {
                    this.primaryContactRows[i].contact_type_error_msg = "Select contact type";
                    success = false;
                }
                if (this.primaryContactRows[i].contact_name == '' || this.primaryContactRows[i].contact_name == null) {
                    this.primaryContactRows[i].contact_name_error_msg = "Enter contact name";
                    success = false;
                }

                if (this.primaryContactRows[i].contact_email == '' || this.primaryContactRows[i].contact_email == null) {
                    this.primaryContactRows[i].contact_email_error_msg = "Enter email";
                    success = false;
                } else {
                    if (!this.validEmail(this.primaryContactRows[i].contact_email)) {
                        this.primaryContactRows[i].contact_email_error_msg = "Enter valid email";
                        success = false;
                    }
                }

                if (this.primaryContactRows[i].contact_phone == '' || this.primaryContactRows[i].contact_phone == null) {
                    this.primaryContactRows[i].contact_phone_error_msg = "Enter phone";
                    success = false;
                }
            }
            return success;
        },
        clearPrimaryContactRowErrorMsg(index) {
            this.primaryContactRows[index].contact_type_error_msg = "";
            this.primaryContactRows[index].contact_name_error_msg = "";
            this.primaryContactRows[index].contact_email_error_msg = "";
            this.primaryContactRows[index].contact_phone_error_msg = "";
        },
        validateSoftwareRows() {
            var success = true;
            for (var i = 0; i < this.softwareRows.length; i++) {
                this.clearSoftwareRowErrorMsg(i);
                if (this.softwareRows[i].software_name == '' || this.softwareRows[i].software_name == null) {
                    this.softwareRows[i].software_name_error_msg = "Select software name";
                    success = false;
                }
                if (this.softwareRows[i].start_date == '' || this.softwareRows[i].start_date == null) {
                    this.softwareRows[i].start_date_error_msg = "Enter start date";
                    success = false;
                }

                if (this.softwareRows[i].exp_date == '' || this.softwareRows[i].exp_date == null) {
                    this.softwareRows[i].exp_date_error_msg = "Enter expiry date";
                    success = false;
                }

                if (this.softwareRows[i].invoice_number == '' || this.softwareRows[i].invoice_number == null) {
                    this.softwareRows[i].invoice_number_error_msg = "Enter invoice number";
                    success = false;
                }

                if (this.softwareRows[i].admin_name == '' || this.softwareRows[i].admin_name == null) {
                    this.softwareRows[i].admin_name_error_msg = "Admin Name Required";
                    success = false;
                }
            }
            return success;
        },
        clearSoftwareRowErrorMsg(index) {
            this.softwareRows[index].software_name_error_msg = "";
            this.softwareRows[index].start_date_error_msg = "";
            this.softwareRows[index].exp_date_error_msg = "";
            this.softwareRows[index].invoice_number_error_msg = "";
            this.softwareRows[index].admin_name_error_msg = "";
        },
        validateDocumentRows() {
            var success = true;
            for (var i = 0; i < this.documentRows.length; i++) {
                this.clearDocumentRowErrorMsg(i);
                if (this.documentRows[i].document_type == '' || this.documentRows[i].document_type == null) {
                    this.documentRows[i].document_type_error_msg = "Select document type";
                    success = false;
                }
                if (
                    (this.documentRows[i].file == '' || this.documentRows[i].file == null)
                    &&
                    (this.documentRows[i].file_link == '' || this.documentRows[i].file_link == null)
                ) {
                    this.documentRows[i].file_error_msg = "Upload file";
                    success = false;
                }
            }
            return success;
        },
        clearDocumentRowErrorMsg(index) {
            this.documentRows[index].document_type_error_msg = "";
            this.documentRows[index].file_error_msg = "";
        },
        setAttachments(formData, attachments, $text) {
            for (let i = 0; i < attachments.length; i++) {
                formData.append($text + '-' + i, attachments[i].file);
            }
            return formData;
        },
        populateDocumentRows(dealerAccountDocument) {
            this.documentRows = [];
            for (let i = 0; i < dealerAccountDocument.length; i++) {
                this.documentRows.push({
                    id: dealerAccountDocument[i].id,
                    document_type: dealerAccountDocument[i].document_type,
                    file_error_msg: "",
                    document_type_error_msg: "",
                    file: "",
                    file_link: (dealerAccountDocument[i].uploaded_file != "") ? dealerAccountDocument[i].uploaded_file : null,
                    dealer_id: dealerAccountDocument[i].dealer_id
                });
            }
        },
        goToGetDocumentPath(event, link) {
            event.preventDefault();
            var self = this;
            var path = link;
            var flag = '';
            var id = 0;
            self.getDocumentPath(id, path, flag);
        },
        removeFileLink(index) {
            this.documentRows[index].file_link = null;
        },

        populateShipToRows(dealerShipToRows) {
            this.shipToRows = [];
            for (let i = 0; i < dealerShipToRows.length; i++) {
                this.shipToRows.push({
                    id: dealerShipToRows[i].id,
                    company_name: dealerShipToRows[i].company_name,
                    address: dealerShipToRows[i].address,
                    state_id: dealerShipToRows[i].state_id,
                    city: dealerShipToRows[i].city,
                    zipcode: dealerShipToRows[i].zipcode,
                    stateArr: [],
                    cityArr: [],
                    company_name_error_msg: '',
                    address_error_msg: '',
                    state_id_error_msg: '',
                    city_error_msg: '',
                    zipcode_error_msg: '',
                });
            }
        },

        populatePrimaryContactsRows(dealerPrimaryContacts) {
            this.primaryContactRows = [];
            for (let i = 0; i < dealerPrimaryContacts.length; i++) {
                this.primaryContactRows.push({
                    contact_id: dealerPrimaryContacts[i].contact_id,
                    contact_type: dealerPrimaryContacts[i].contact_type,
                    contact_name: dealerPrimaryContacts[i].contact_name,
                    contact_email: dealerPrimaryContacts[i].contact_email,
                    contact_phone: dealerPrimaryContacts[i].contact_phone,
                    contact_type_error_msg: '',
                    contact_name_error_msg: '',
                    contact_email_error_msg: '',
                    contact_phone_error_msg: ''
                })
            }
        },

        populateSoftwareRows(dealerSoftwareRows) {
            this.softwareRows = [];
            for (let i = 0; i < dealerSoftwareRows.length; i++) {
                this.softwareRows.push({
                    id: dealerSoftwareRows[i].id,
                    software_name: dealerSoftwareRows[i].software_name,
                    software_name_error_msg: '',
                    start_date: dealerSoftwareRows[i].start_date,
                    start_date_error_msg: '',
                    exp_date: dealerSoftwareRows[i].exp_date,
                    exp_date_error_msg: '',
                    invoice_number: dealerSoftwareRows[i].invoice_number,
                    invoice_number_error_msg: ''
                })
            }
        },
        formatNumeric(type) {
            if (type == "labor_rate") {
                if ((!this.approved_labor_rate.includes('$')) && this.approved_labor_rate != "") {
                    this.approved_labor_rate = this.formatCurrency(this.approved_labor_rate);
                }
            } else {
                if ((!this.approved_travel_time_rate.includes('$')) && this.approved_travel_time_rate != "") {
                    this.approved_travel_time_rate = this.formatCurrency(this.approved_travel_time_rate);
                }
                if ((!this.approved_travel_distance_rate.includes('$')) && this.approved_travel_distance_rate != "") {
                    this.approved_travel_distance_rate = this.formatCurrency(this.approved_travel_distance_rate);
                }
            }
        },
        populateAmounts() {
            this.approved_labor_rate = this.formatCurrency(this.approved_labor_rate);
            this.approved_travel_time_rate = this.formatCurrency(this.approved_travel_time_rate);
            this.approved_travel_distance_rate = this.formatCurrency(this.approved_travel_distance_rate);
        },
        goToGetLogInfo(logId) {
            var self = this;
            var logFlag = 'RATE_AUDIT';

            self.getLogInfo(logId, logFlag);
        },
    }
};
</script>



// WEBPACK FOOTER //
// src/components/CustomerCreate.vue